import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { xxllncColor } from '../../layout/themes'

export const PREFIX = 'xxllncContactPanel'

export const classes = {
  card: `${PREFIX}-card`,
  searchBar: `${PREFIX}-searchBar`,
  searchButton: `${PREFIX}-searchButton`,
  avatar: `${PREFIX}-avatar`,
  avatarAnon: `${PREFIX}-avatarAnon`,
  expandButton: `${PREFIX}-expandButton`,
  scrollContainer: `${PREFIX}-scrollContainer`,
}

export const StyledBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',

  [`& .${classes.card}`]: {
    padding: theme.spacing(2.5),
    borderRadius: '12px',
    backgroundColor: xxllncColor.dark20,
    boxShadow: 'none',
  },

  [`& .${classes.avatar}`]: {
    backgroundColor: xxllncColor.gamboge,
    color: xxllncColor.black,
    borderRadius: '50%',
    width: 44,
    height: 44,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: theme.spacing(1.5),
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },

  [`& .${classes.avatarAnon}`]: {
    backgroundColor: xxllncColor.black,
    color: '#fff',
    borderRadius: '50%',
    width: 40,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: theme.spacing(1.5),
  },

  [`& .${classes.searchBar}`]: {
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#fff',
    borderRadius: '4px',
    border: `1px solid ${xxllncColor.alto}`,
    overflow: 'hidden',
    height: '40px',
    marginTop: theme.spacing(1),
  },

  [`& .${classes.searchButton}`]: {
    padding: '8px',
    backgroundColor: xxllncColor.veniceBlue,
    color: '#fff',
    borderRadius: 0,
  },

  [`& .${classes.expandButton}`]: {
    'backgroundColor': '#fff',
    'boxShadow': '0px 2px 4px rgba(0,0,0,0.25)',
    '&:hover': { backgroundColor: '#f5f5f5' },
    'padding': theme.spacing(0.5),
    'width': 28,
    'height': 28,
  },

  [`& .${classes.scrollContainer}`]: {
    'marginTop': theme.spacing(2),
    'paddingLeft': theme.spacing(1),
    'paddingRight': theme.spacing(1),
    'maxHeight': 'calc(100vh - 420px)',
    'overflowY': 'auto',
    '&::-webkit-scrollbar': { width: '5px' },
    '&::-webkit-scrollbar-thumb': {
      background: xxllncColor.alto,
      borderRadius: '10px',
    },
  },
}))